<!--
 * @Description: 
 * @Author: 朱海良
 * @Date: 2022-08-23 18:26:16
 * @LastEditors: 朱海良
 * @LastEditTime: 2022-08-31 15:05:01
-->
<template>
  <div id="app">
    <Head />
    <router-view class="body" />
    <Foot />
  </div>
</template>

<script lang="ts">
import Head from "@/components/head.vue";
import Foot from "@/components/foot.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    Head,
    Foot,
  },
})
export default class App extends Vue {}
</script>
<style lang="less">
@media screen and (max-width: 600px) {
  #app {
    width: 100% !important;
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 1200px;
  margin: auto;
  min-height: 100vh;
  background: #fff;
  .body {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
